import { Dictionary } from '@sber-site/geo-kit/src/types';

import * as urls from './urls';

const notOkMessage = 'Response not ok';

export async function loadSettings(serviceName: string, defaultSettings = {}): Promise<Dictionary<string>> {
    const response = await fetch(`${urls.SETTINGS_URL}?serviceName=${serviceName}`);

    if (!response.ok) {
        throw new Error(notOkMessage);
    }

    const settings = await response.json();

    return settings.reduce(
        (result: Dictionary<string>, item: { propertyName: string; propertyValue: string }) => ({
            ...result,
            [item.propertyName]: item.propertyValue || result[item.propertyName],
        }),
        defaultSettings
    );
}
